import { render, staticRenderFns } from "./Footerbar.vue?vue&type=template&id=1bb0e896&scoped=true"
import script from "./Footerbar.vue?vue&type=script&lang=js"
export * from "./Footerbar.vue?vue&type=script&lang=js"
import style0 from "./Footerbar.vue?vue&type=style&index=0&id=1bb0e896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb0e896",
  null
  
)

export default component.exports